// extracted by mini-css-extract-plugin
export default {"owner":"jVIHfI60GEEIbZ0y9ZAO","ownerBadge":"fOP0xMtc_XcZNPY2qHr1","date":"z7yUvKhO3eMpDT4TqI_z"};